<head>

  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">


  <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
    integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
</head>


<div class="container-fluid">
  <div class="row">
    <div class="col-md-4 insured">
      <fieldset>
        <legend>Detail</legend>

        <label>Insured:</label>
        <select name="select" [(ngModel)]="policy.accountID" >
          <option hidden selected disabled>Insured</option>
          <option ngDefaultControl *ngFor="let dropAcc of  insured " [ngValue]="dropAcc.id">{{dropAcc.name}}</option>
        </select>
        <label>Policy Number:</label>
        <input type="text" [(ngModel)]="policy.policyNumber">

        <label>Policy Type</label>
        <select  [(ngModel)]="policy.policyTypeID">
          <option ngDefaultControl *ngFor="let dropPolT of  polTy" [ngValue]="dropPolT.id">{{dropPolT.name}}</option>
        </select>
        <label>Policy Status:</label>
        <select  [(ngModel)]="policy.policyStatusID">
          <!-- <option hidden selected disabled>Policy Status</option> -->
          <option ngDefaultControl *ngFor="let dropPolS of  polS" [ngValue]="dropPolS.id">{{dropPolS.name}}</option>

        </select>
        <label>Contract:</label>
        <select  [(ngModel)]="policy.contractID">
          <option ngDefaultControl *ngFor="let dropCon of Con" [ngValue]="dropCon.id">{{dropCon.name}}</option>
        </select>
      
          <label>Effective Date: </label>
          <mat-form-field appearance="outline" style="font-size:3px;width:49%;">
          <input style="font-size:15px;"  matInput [(ngModel)]="policy.effectiveDate " [matDatepicker]="picker"
          >
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <!-- [ngModelOptions]="{standalone:true}" -->
        <label>Expiration Date: </label>
        <mat-form-field appearance="outline" style="font-size:3px;width:49%;">
          <input style="font-size:15px;"  matInput [(ngModel)]="policy.expirationDate " [matDatepicker]="picker1"
          >
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <!-- <input type="text" [ngModel]="policy.expirationDate | date: 'MM/dd/yyyy'"> -->
        <!--  (ngModelChange)="policy.expirationDate=$event" [ngModelOptions]="{standalone:true}" -->


        <label>Accept New Member Policies:</label>
        <input class="checkbox" type="checkbox" [(ngModel)]="policy.acceptNewMemberPolicies">
        <label>Accept Member Policy Renewals:</label>
        <input class="checkbox" type="checkbox" [(ngModel)]="policy.acceptMemberPolicyRenewals">
        <label>Insured Name On Certificate:</label>
        <input type="text" [(ngModel)]="policy.insuredNameOnCertificate">
      </fieldset>
    </div>
    <div class="col-md-4 rates">
      <fieldset>
        <legend>Rates</legend>

        <label>Insured Value Rate:</label>
        <input type="number" [(ngModel)]="policy.insuredValueRate">
        <label>Additional Insured Rate:</label>
        <input type="number" [(ngModel)]="policy.additionalInsuredRate" >
        <label>Application Fee:</label>
        <input type="number" [(ngModel)]="policy.applicationFee">
        <label>Minimum Premium:</label>
        <input type="number" [(ngModel)]="policy.minimumPremium">
        <label>Minimum Premium Custom:</label>
        <input class="checkbox" type="checkbox" [(ngModel)]="policy.minimumPremiumCustom">


      </fieldset>
      <fieldset class="notes">
        <legend>Notes</legend>
        <textarea  rows="5"  [(ngModel)]="policy.notes"></textarea>

      </fieldset>
    </div>
    <div class="col-md-4 limits">
      <fieldset>
        <legend>Limits</legend>


        <label>Each Occurrence:</label>
        <input type="number" [(ngModel)]="policy.eachOccurrence">

        <label>Damage To Rented Premises:</label>
        <input type="number" [(ngModel)]="policy.damageToRentedPremises">

        <label>Damage To Rented Premises Excluded:</label>
        <input class="checkbox" type="checkbox" [(ngModel)]="policy.damageToRentedPremisesExcluded">

        <label>Medical Expense:</label>
        <input type="number" [(ngModel)]="policy.medicalExpense">

        <label>Medical Expense Excluded:</label>
        <input class="checkbox" type="checkbox" [(ngModel)]="policy.medicalExpenseExcluded!">

        <label>Personal Advertising Injury:</label>
        <input type="number" [(ngModel)]="policy.personalAdvertisingInjury">


        <label>Personal Advertising Injury Excluded:</label>
        <input class="checkbox" type="checkbox" [(ngModel)]="policy.personalAdvertisingInjuryExcluded">

        <label>General Aggregate:</label>
        <input type="number" [(ngModel)]="policy.generalAggregate">
        <label>Products Completed Operations Aggregate: </label>
        <input type="number" [(ngModel)]="policy.productsCompletedOperationsAggregate">

        <label>Products Completed Operations Aggregate
          Excluded:</label>
        <input class="checkbox" type="checkbox" [(ngModel)]="policy.productsCompletedOperationsAggregateExcluded">

      </fieldset>
    </div>
    <div *ngIf="isLoading" class="spinner-wrapper">
      <mat-spinner diameter="32" color="primary"></mat-spinner>
    </div>
  </div>
  <div class="row" >
  <mat-tab-group animationDuration="0ms" >
    <mat-tab label="Premium Transactions"> 
      <div>
        <nav class="navbar navbar-light bg-light justify-content-between">
          <a class="navbar-brand"></a>
          <div class="input-group search-style">
            <input  class="form-control mr-sm-1" type="search" [(ngModel)]="searchTerm"
              placeholder="Search">
            <div class="input-group-append">
              <button class="btn removefocus" type="button" (click)="search()" *ngIf="!isSearching">
                <i class="fa fa-search"></i>
              
              <button class="btn removefocus" type="button" (click)="clearSearch()" *ngIf="isSearching">
                <i class="fa fa-times"></i>
              </button>
            </button>
            </div>
          </div>
        </nav>
        <section class="table-container" [ngClass]="{ 'table-container-collapsed':!dynamicTabService.isCollapsed}" tabindex="0">
          <table mat-table [dataSource]="dataSource" class="table table-bordered">

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>
                <button class="btn btn-link" (click)="sortData('name')" matTooltip="Sort by Account">
                  Account
                  <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='name'"
                    [class.fa-sort-asc]="sortingColumn ==='name' && sortOrder === 'asc'"
                    [class.fa-sort-desc]="sortingColumn ==='name' && sortOrder === 'desc'"></i>
                </button>
              </th>
              <td mat-cell *matCellDef="let policy">{{ policy.name }}</td>
            </ng-container>
            <ng-container matColumnDef="memberPolicyNumber">
              <th mat-header-cell *matHeaderCellDef>
                <button class="btn btn-link" (click)="sortData('memberPolicyNumber')"
                  matTooltip="Sort by Member Policy">
                  Member Policy
                  <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='memberPolicyNumber'"
                    [class.fa-sort-asc]="sortingColumn ==='memberPolicyNumber' && sortOrder === 'asc'"
                    [class.fa-sort-desc]="sortingColumn ==='memberPolicyNumber' && sortOrder === 'desc'"></i>
                </button>
              </th>
              <td mat-cell *matCellDef="let policy">{{ policy.memberPolicyNumber}}</td>
            </ng-container>
            <ng-container matColumnDef="transactionDate">
              <th mat-header-cell *matHeaderCellDef>
                <button class="btn btn-link" (click)="sortData('transactionDate')"
                  matTooltip="Sort by Transaction Date">
                  Transaction Date
                  <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='transactionDate'"
                    [class.fa-sort-asc]="sortingColumn ==='transactionDate' && sortOrder === 'asc'"
                    [class.fa-sort-desc]="sortingColumn ==='transactionDate' && sortOrder === 'desc'"></i>
                </button>
              </th>
              <td mat-cell *matCellDef="let policy">{{ policy.transactionDate | date :"MM/dd/yyy"}}</td>
            </ng-container>
            <ng-container matColumnDef="transactionType">
              <th mat-header-cell *matHeaderCellDef>
                <button class="btn btn-link" (click)="sortData('transactionType')"
                  matTooltip="Sort by Transaction Type">
                  Transaction Type
                  <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='transactionType'"
                    [class.fa-sort-asc]="sortingColumn ==='transactionType' && sortOrder === 'asc'"
                    [class.fa-sort-desc]="sortingColumn ==='transactionType' && sortOrder === 'desc'"></i>
                </button>
              </th>
              <td mat-cell *matCellDef="let policy">{{ policy.transactionType}}</td>
            </ng-container>
            <ng-container matColumnDef="insuredValueChange">
              <th mat-header-cell *matHeaderCellDef>
                <button class="btn btn-link" (click)="sortData('insuredValueChange')"
                  matTooltip="Sort by Insured Value Change">
                  Insured Value Change
                  <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='insuredValueChange'"
                    [class.fa-sort-asc]="sortingColumn ==='insuredValueChange' && sortOrder === 'asc'"
                    [class.fa-sort-desc]="sortingColumn ==='insuredValueChange' && sortOrder === 'desc'"></i>
                </button>
              </th>
              <td mat-cell *matCellDef="let policy">{{ policy.insuredValueChange }}</td>
            </ng-container>
            <ng-container matColumnDef="premiumChange">
              <th mat-header-cell *matHeaderCellDef>
                <button class="btn btn-link" (click)="sortData('premiumChange')"
                  matTooltip="Sort by Premium Change">
                  Premium Change
                  <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='premiumChange'"
                    [class.fa-sort-asc]="sortingColumn ==='premiumChange' && sortOrder === 'asc'"
                    [class.fa-sort-desc]="sortingColumn ==='premiumChange' && sortOrder === 'desc'"></i>
                </button>
              </th>
              <td mat-cell *matCellDef="let policy">{{ policy.premiumChange}}</td>
            </ng-container>
            <ng-container matColumnDef="commands">
              <th mat-header-cell *matHeaderCellDef>
                <button class="btn btn-link" matTooltip="Commands is not sortable">
                  Commands
                </button>
              </th>
              <td mat-cell *matCellDef="let policy">
                <nav>
                  <button class="btn btn-sm btn-outline-secondary glossy-button" type="button" (click)="openMemberPolicy(policy.memberPolicyNumber)">
                    Open Member Policy</button>
                </nav>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky: true" class="headerstyle"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
          </table>
        </section>
        <!-- Pagination -->
        
        <div>
          <mat-paginator class="pagination" [length]="totalItems" [hidePageSize]="isHidePageSize"
          [showFirstLastButtons]="showFirstLastButtons" (page)="onPageChange($event)" aria-label="Select page">
          </mat-paginator>
        </div>
     
    
      </div>
         <!-- Table spinner -->
    <div *ngIf="isLoading" class="spinner-wrapper">
      <mat-spinner diameter="32" color="primary"></mat-spinner>
    </div>
    </mat-tab>
    <mat-tab label="More">
      <div class="row">
      <div class="col-md-2">
        <label class="form-label">&nbsp;Minimum Premium Script:</label>
      </div>
        <div class="col-md-6">
          <textarea class="form-control" rows="3" [(ngModel)]="policy.minimumPremiumScript"></textarea>
        </div>
      </div>
      <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-6 tracking">
        <form>
          <fieldset >
            <legend>Tracking</legend> 
            <div class="col-md-6">
            <label >Created:</label>{{policy.created | date:"MM/dd/yyyy  h:mm a "}}
            <label >Created By User:</label>{{policy.createdUser}}
            <label >Last Updated:</label>{{policy.lastUpdated | date:"MM/dd/yyyy  h:mm a "}}
            <label >Last Updated By User:</label>{{policy.lastUpdatedUser}}
          </div>
          </fieldset>
        </form>
      </div>
       
      </div>  
    </mat-tab>
    
  </mat-tab-group>
</div>
